define.alias("shared/utils/image-tag", "settings/utils/image-tag");